function intervalService($interval, $window, auth) {
	const service = this;

	service.process = null;
	service.start = start;
	service.stop = stop;

	function start() {
		if(service.process) {
			return;
		}

		const authData = angular.fromJson(
			$window.sessionStorage.getItem("authData")
		);

		if(authData) {
			const time = (authData.expires - authData.issued) * 0.9 * 1000;
			service.process = $interval(function() {
				auth.refreshAccessToken();
			}, time);
		}
	}

	function stop() {
		if(service.process) {
			$interval.cancel(service.process);
		}
		service.process = null;
	}

	return service;
}

export default angular
	.module("vesl.services.interval-service", [])
	.service("intervalService", intervalService).name;
